import React from 'react';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { Entry } from 'contentful';

import Article from '../components/Article';

import SectionsList from 'components/SectionsList';
import MobileSectionsList from 'components/MobileSectionsList';
import {
  ContentfulArticle,
  SectionTree,
  SectionTypeTree,
  ContentfulCountry,
} from 'types/common';
import {
  PageNavigation,
  PageContent,
  PreviewEditButton,
} from 'components/styledComponents';
import { Row } from 'components/TypedCircuit';
import { makeContentfulEntryUrl } from 'services/contentful';

type ArticlePageProps = {
  sectionTree: SectionTree;
  articleData: ContentfulArticle;
  countriesData: Entry<ContentfulCountry>[];
  articleId: string;
  preview: boolean | null;
  sectionTypeTree: SectionTypeTree;
  chatAvailable: boolean;
};

const Page: NextPage<ArticlePageProps> = ({
  sectionTree,
  articleData,
  preview,
  sectionTypeTree,
  countriesData,
  chatAvailable,
}) => {
  const router = useRouter();
  if (router.isFallback) {
    return <div>Page is loading. This is the loader to show meanwhile</div>;
  }

  return (
    <Row>
      <PageNavigation span="0" skip="0">
        <MobileSectionsList
          sectionTypeTree={sectionTypeTree}
          sectionTree={sectionTree}
        />
        <SectionsList
          sectionTypeTree={sectionTypeTree}
          sectionTree={sectionTree}
        />
      </PageNavigation>
      <PageContent span="0" skip="0">
        {preview && (
          <PreviewEditButton
            href={makeContentfulEntryUrl(articleData.sys.id)}
            target="blank"
          >
            Edit
          </PreviewEditButton>
        )}
        {articleData && (
          <Article
            articleData={articleData}
            countriesData={countriesData}
            chatAvailable={chatAvailable}
          />
        )}
      </PageContent>
    </Row>
  );
};

export default Page;
